import { gql } from '@apollo/client'

export const STOP_OPTIMIZATIONS = gql`
  mutation StopOptimizations($input: OptimizationsInput!) {
    stopOptimizationsInCompanyStores(input: $input) {
      success
      storeIds
      optimizingPausedAt
    }
  }
`
